import React from 'react'
import { Container, Row, Form, Button} from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import '../App.css'
import logo from "../assets/logo-vinidaily-white.png"
import {Redirect} from 'react-router-dom'


class IdentifyCommand extends React.Component {  
    constructor(){
        super();

        this.state = {
            orderId : "",
        }
    }
    submit(e){
        e.preventDefault()
        this.setState({
            formComplete: true
        })
    }

    handleChangeNumber(e){
        this.setState({
            orderId:e.target.value
        })
    }

    render() {
        if (this.state.formComplete){
            return <Redirect to={{ pathname:'/delivery', state: {id: this.state.orderId}}}/>
        }
        else{
            return (
                <Container>
                    <Container className="container1">
                        <Container className="container2">
                        <Row className="logo">
                                <img alt="Vinidaily" src={logo}/>
                        </Row>
                            <Form onSubmit={(e)=>this.submit(e)} style={{marginTop:100}}>
                                <Form.Group className="input-form" controlId="formBasicEmail" style={{marginTop:35}}>
                                    <Row style={{textAlign:"center"}}>
                                        <Form.Label style={{ fontWeight:700, fontSize: "2rem",color: "#fff"}}>Votre numéro de commande  </Form.Label>
                                    </Row>
                                    <Row style={{textAlign:"center"}}>
                                        <Form.Control
                                            className="inputr"
                                            style={{fontSize:"1.5rem",  paddingLeft:50 , border: "None", borderRadius: "5px", borderBottom: "1px solid #d2d2dc",height:"50px", marginTop:30}}
                                            type="number"
                                            value={this.state.orderId}
                                            placeholder="&#8470;  0000000"
                                            onChange={e => this.handleChangeNumber(e)}/>
                                    </Row>
                                </Form.Group>

                                {this.state.orderId.length ===5 &&(<Form.Group style={{display : "flex"}}>
                                    <Button
                                        className="submit"
                                        type="submit">
                                        Activer votre commande</Button>
                                </Form.Group>)}

                            </Form>
                    </Container>
                </Container>
                </Container>
            )
            }
    }
}

export default withRouter(IdentifyCommand)